import { NextPageFC } from '@shared/models/next-fc'
import { GetServerSideProps } from 'next'
import AppPrivacyPolicy from 'screens/app-privacy-policy'

const AppPrivacyPolicyPage: NextPageFC = () => AppPrivacyPolicy()

AppPrivacyPolicyPage.layout = AppPrivacyPolicy

AppPrivacyPolicyPage.headProps = {
	title: 'Политика конфиденциальности мобильного приложения «Credit.Club Деньги»',
	description:
		'Ознакомьтесь на странице с политикой конфиденциальности мобильного приложения «Credit.Club Деньги»',
}

export const getServerSideProps: GetServerSideProps = async () => {
	return {
		props: {},
	}
}

export default AppPrivacyPolicyPage
